const BUSINESS = {
  organization: "business",
  Organization: "Business",
  customers: "customers",
  Customers: "Customers",
  clients: "clients",
  sales: "sales",
  leads: "leads",
  Leads: "Enquiries",
  products: "products",
  offers: "offers",
  Offers: "Offers",
  competitors: "competitors",
  adCampaign: "Ad campaign",
  services: "Services",
  growth: "Growth roadmap",
  funding: "Funding readiness",
  launch: "Product launch",
  idealProfiles: "Ideal customer profiles",
  audience: "audience",
};

const MINISTRY = {
  organization: "ministry",
  Organization: "Ministry",
  customers: "congregation",
  Customers: "Congregation",
  clients: "community",
  sales: "outreach",
  leads: "connections",
  Leads: "Connections",
  products: "programs",
  offers: "programs & ministries",
  Offers: "Programs & ministries",
  competitors: "similar ministries in our area",
  adCampaign: "Outreach campaign",
  services: "Ministries",
  growth: "Ministry growth roadmap",
  funding: "Grants & donor readiness",
  launch: "Event / program launch",
  idealProfiles: "People we serve",
  audience: "community",
};

export const isMinistry = value => ["ministry", "nonprofit"].includes(typeof value === "object" ? value?.org_type : value);
export const vocab = value => {
  const type = typeof value === "object" ? value?.org_type : value;
  if (!isMinistry(type)) return BUSINESS;
  const kind = typeof value === "object" ? value?.mission_profile?.kind : null;
  const church = kind === "church";
  const nonprofit = ["nonprofit","mission_organization"].includes(kind) || (!kind && type === "nonprofit");
  return {...MINISTRY, organization: nonprofit ? "organization" : church ? "church" : "ministry", Organization: nonprofit ? "Organization" : church ? "Church" : "Ministry",
    customers: church ? "congregation" : "community", Customers: church ? "Congregation" : "Community",
    offers: church ? "ministries & programs" : "programs & services", Offers: church ? "Ministries & programs" : "Programs & services",
    services: church ? "Ministries" : "Programs", competitors: "organizations serving similar needs",
    growth: "Mission & engagement", funding: "Giving & partnership readiness"};
};

export const CATEGORY_META = {
  identity: { label: "Identity", blurb: "Who you are and why you exist" },
  audience: { label: "Audience", blurb: "Who you serve and what they feel" },
  positioning: { label: "Positioning", blurb: "What you offer and how you stand apart" },
  voice: { label: "Voice", blurb: "How you sound" },
  proof: { label: "Proof", blurb: "What you can honestly stand behind" },
  guardrails: { label: "Guardrails", blurb: "What your marketing must never say" },
  visual: { label: "Visual", blurb: "How you look" },
};

export const PROVENANCE = {
  ai_derived: { label: "Proposed by AI", tone: "gold" },
  customer_confirmed: { label: "Accepted", tone: "ok" },
  customer_stated: { label: "You wrote this", tone: "ok" },
};
